﻿$.fn.dxCtrlSaisieAdresse = function custom_dxCtrlSaisieAdresse(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlsaisieadresse dx-ctrl");
        this.createInstance(new cdxCtrlSaisieAdresse(this, option));
    }
    return this;
}


window.cdxCtrlSaisieAdresse = function (container, option) {
    var Me = this;
    if (typeof option.value == 'undefined' || option.value == null) option.value = {
        ad1: null,
        ad2: null,
        ad3: null,
        cp: null,
        ville: null,
        cedex: null,
        dpt: null,
        region: null,
        pays: null,
        code_pays: null,
        latitude: null,
        longitude: null,
        normalise: 0
    }

    if (typeof option.lib_latitude == 'undefined') option.lib_latitude = "latitude"
    if (typeof option.lib_longitude == 'undefined') option.lib_longitude = "longitude"

    this.option = function (name, value) {
        if (name == "value") {
            if (typeof value == 'undefined') {
                return option[name];
            }
            else {
                option[name] = value;
                mConstruit()
            }
        } else {
            if (typeof value == 'undefined') {
                return dx.option(name);
            }
            else {
                dx.option(name, value);
            }
        }

    }

    //var disableOnValueChanged = false
    var $DivJaugeSaisie = null
    var dx = null
    var dxBtFlag = null
    var dxBtNormalise = null
    var dxBtGeocode = null
    var dxBtModif = null
    this.isDirty = false
    function mConstruit() {
        container.empty();
        container.css("position", "relative")

        if (typeof option.obligatoire != 'undefined' && option.obligatoire) container.addClass("saisie_obligatoire")

        var buttons = []
        if (!option.hideButton) {
            buttons.push({ //flag
                name: 'flag',
                location: 'before',
                options: {
                    icon: '',
                    disabled: true,
                    visible: false,
                    width: 32,
                    onContentReady: function (e) {
                        dxBtFlag = e.component
                        e.component.element().attr("title", "")
                        e.component.element().css("margin", "0")
                    }
                },
            })
            buttons.push({ //geocode
                name: 'geocode',
                location: 'after',
                options: {
                    icon: "fas fa-map-location-dot",
                    visible: false,
                    width: 32,
                    focusStateEnabled: false,
                    onClick(e) {
                        e.event.stopPropagation()
                        mShowListAdresse(e.component.element(), "geoloc")
                        //mShowPopupAdressePostale();
                    },
                    onContentReady: function (e) {
                        dxBtGeocode = e.component
                        e.component.element().attr("title", "Cette adresse postale n'est pas géocodée,<br/>c'est à dire que elle ne dispose pas de coordonnées GPS pour être placé sur une carte.<br/>Choisissez une adresse dans la liste ou cliquez pour la géocoder manuellement.")
                        e.component.element().css("margin", "0")
                        e.component.element().find(".dx-icon").css("color", "red")
                    }
                },
            })
            buttons.push({ //normalise
                name: 'normalise',
                location: 'after',
                options: {
                    icon: 'fas fa-compass-drafting',
                    visible: false,
                    width: 32,
                    focusStateEnabled: false,
                    onClick(e) {
                        e.event.stopPropagation()
                        mShowListAdresse(e.component.element(), "normalise")
                        //var tt = $("<div/>").appendTo("body").dxCtrlTooltip({
                        //    target: e.component.element(),
                        //    width: 300,
                        //    minHeight: 100,
                        //    contentTemplate: function (contentElement) {
                        //        contentElement.css("padding", "20px 10px")
                        //        var jauge = $("<div/>").appendTo(contentElement).dxCtrlJauge({ width: 30, height: 30 }).dxCtrlJauge("instance")
                        //        jauge.mShow();
                        //        var resumeAdresse = (new cAdresse(option.value)).mGetLibelleLong();
                        //        (new cGoogleMapsApi(option.bddCtrl)).mGetLstAdressFromString(resumeAdresse, function (lstAdresse) {
                        //            if (lstAdresse.length > 0) {
                        //                $("<div style='font-size:120%;font-weight:bold;'>Choisissez l'adresse pour la normalisation</div>").appendTo(contentElement)
                        //                lstAdresse.forEach(function (itemData, idx) {
                        //                    itemData.ad1 = itemData.adr
                        //                    delete itemData.adr
                        //                    if (idx > 0) $("<br/>").appendTo(contentElement)
                        //                    var resAdresse = (new cAdresse(itemData)).mGetLibelleLong(true,true);
                        //                    var $DivAdr = $("<div class='state-hover dx-widget dx-button dx-button-mode-contained dx-button-normal dx-button-has-text' " +
                        //                        "style='padding:10px;width:calc(100% - 40px);height:auto;text-align:left;line-height:1;margin-top:10px;'>" +
                        //                        "<div>" +
                        //                        "<span style='font-family:barlow condensed;white-space:normal;'>" + resAdresse + "</span>" +
                        //                        "</div>" +
                        //                        "</div>").appendTo(contentElement)
                        //                    $DivAdr.on("click", function (e) {
                        //                        tt.hide()
                        //                        option.value.ad1 = itemData.ad1
                        //                        option.value.cp = itemData.cp
                        //                        option.value.ville = itemData.ville
                        //                        option.value.dpt = itemData.dpt
                        //                        option.value.region = itemData.region
                        //                        option.value.pays = itemData.pays
                        //                        option.value.code_pays = itemData.code_pays
                        //                        option.value[option.lib_latitude] = itemData.latitude
                        //                        option.value[option.lib_longitude] = itemData.longitude
                        //                        option.value.normalise = 1
                        //                        if (typeof option.onValueChanged != 'undefined') option.onValueChanged(option.value)
                        //                        mConstruit()
                        //                    })
                        //                })
                        //                $("<br/>").appendTo(contentElement)
                        //                var $DivAdr = $("<div class='state-hover dx-widget dx-button dx-button-mode-contained dx-button-normal dx-button-has-text' " +
                        //                    "style='padding:10px;width:calc(100% - 40px);height:auto;text-align:left;line-height:1;margin-top:20px;text-align:center;'>" +
                        //                    "<div style='text-align:center;font-size:120%;width:100%'>" +
                        //                    "<span style='font-family:barlow condensed;white-space:normal;'>OUVRIR L'ADRESSE POSTALE...</span>" +
                        //                    "</div>" +
                        //                    "</div>").appendTo(contentElement)
                        //                $DivAdr.on("click", function (e) {
                        //                    tt.hide()
                        //                    mShowPopupAdressePostale();
                        //                })
                        //            } else {
                        //                tt.hide()
                        //                mShowPopupAdressePostale();
                        //                window.setTimeout(function (e) {
                        //                    mNotify("Impossible de normaliser l'adresse. Aucune adresse trouvée.", "warning", 6000)
                        //                }, 1000)
                        //            }
                        //            jauge.mHide()
                        //        })
                        //    }
                        //}).dxCtrlTooltip("instance")
                        //tt.show()
                        ////mShowPopupAdressePostale();
                    },
                    onContentReady: function (e) {
                        dxBtNormalise = e.component
                        e.component.element().attr("title", "Cette adresse postale n'est pas normalisée,<br/>c'est à dire qu'elle n'est pas saisie correctement.<br/>Cliquez pour la normaliser.")
                        e.component.element().css("margin", "0")
                        e.component.element().find(".dx-icon").css("color", "red")
                    }
                },
            })
            buttons.push({ //modif
                name: 'modif',
                location: 'after',
                options: {
                    icon: "fas fa-pen",
                    visible: ((typeof option.hideButton == 'undefined') ? true : !option.hideButton),
                    width: 32,
                    focusStateEnabled: false,
                    onClick(e) {
                        e.event.stopPropagation();
                        mShowPopupAdressePostale();
                    },
                    onContentReady: function (e) {
                        dxBtModif = e.component
                        e.component.element().attr("title", "Modifier l'adresse postale.")
                        e.component.element().css("margin", "0")
                    }
                },
            })
        }

        if (typeof option.buttons != 'undefined') option.buttons.forEach(function (bt) { buttons.push(bt) })

        $DivJaugeSaisie = $("<div style='position:absolute;z-index:10;display:none;bottom:1px;width:100%;height:2px;background-color:" + theme.backgroundcolorAccent + ";'><div style='height:100%;width:100%;background-image: url(" + imgJaugeSaisie + ");opacity:1;'></div></div>").appendTo(container)

        //if (Me.hasValue() && option.value.normalise == "0") { dxBtNormalise.option("visible", true) } else { dxBtNormalise.option("visible", false) }
        //if (Me.hasValue() && option.value[option.lib_latitude] == null
        var timeOutRempliDs = null
        //var disableOnValueChanged = false
        var hasValueChanged = false


        var containerDropDown = container
        if (container.closest(".dx-dxctrlgridtemplatedisplay").length>0) containerDropDown = $(container.closest(".dx-dxctrlgridtemplatedisplay"))
        dx = $("<div/>").appendTo(container).dxAutocomplete({
            labelMode: option.labelMode,
            label: option.label,
            dataSource: [],
            value: Me.mResumeAdresse(),
            disabled: option.disabled,
            stylingMode: option.stylingMode,
            placeholder: ((typeof option.placeholder == 'undefined') ? "..." : option.placeholder),
            dropDownOptions: {
                minWidth: 300,
                container: containerDropDown
            },
            openOnFieldClick: false,
            showDropDownButton: true,
            //searchTimeout: 9999999,
            //minSearchLength: 9999999,
            onKeyUp: function (e) {
                if (currentTextSearch != e.component.option("text")) {
                    option.value.ad1 = dx.option("text")
                    option.value.ad2 = null
                    option.value.ad3 = null
                    option.value.cp = null
                    option.value.ville = null
                    option.value.cedex = null
                    option.value.dpt = null
                    option.value.region = null
                    option.value.pays = null
                    option.value.code_pays = null
                    option.value[option.lib_latitude] = null
                    option.value[option.lib_longitude] = null
                    option.value.normalise = 0

                    currentTextSearch = e.component.option("text")
                    //console.log("inputChanged: " + currentTextSearch)
                    e.component.option({
                        "dataSource": []
                    })
                    e.component.close()
                    window.clearTimeout(timeOutRempliDs)
                    if (currentTextSearch != null && currentTextSearch.length > 0) {
                        timeOutRempliDs = window.setTimeout(function () { mRempliDataSource(e.component.option("text")) }, 800);
                        //mRempliDataSource(e.component.option("text"))
                    }
                }
            },
            onItemClick: function (e) {
                var itemData = e.itemData
                if (typeof itemData == "undefined") {
                    const ds = e.component.getDataSource().items();
                    itemData = ds[e.itemIndex]
                }
                e.component.option({
                    "dataSource": [],
                })
                if (typeof itemData != 'undefined') {
                    option.value.ad1 = itemData.adr.trim()
                    option.value.ad2 = ""
                    option.value.ad3 = ""
                    option.value.cp = itemData.cp.trim()
                    option.value.ville = itemData.ville.trim()
                    option.value.cedex = ""
                    option.value.dpt = itemData.dpt.trim()
                    option.value.region = itemData.region.trim()
                    option.value.pays = itemData.pays.trim()
                    option.value.code_pays = itemData.code_pays
                    option.value[option.lib_latitude] = itemData.latitude
                    option.value[option.lib_longitude] = itemData.longitude
                    option.value.normalise = 1
                }


                mMajIndicateur()
                //disableOnValueChanged = true
                dx.option("value", Me.mResumeAdresse())
                //disableOnValueChanged = false
                mMajFlag()

                dx.blur()
                //var serMapApi = new serviceMapsApi()

                //serMapApi.mGetAdresseDetail(e.itemData, function (adressDetail) {
                //    option.value.ad1 = ((typeof adressDetail.ad1 == 'undefined') ? "" : adressDetail.ad1)
                //    option.value.ad2 = ""
                //    option.value.ad3 = ""
                //    option.value.cp = ((typeof adressDetail.cp == 'undefined') ? "" : adressDetail.cp)
                //    option.value.ville = ((typeof adressDetail.ville == 'undefined') ? "" : adressDetail.ville)
                //    option.value.cedex = ((typeof adressDetail.cedex == 'undefined') ? "" : adressDetail.cedex)
                //    option.value.dpt = ((typeof adressDetail.dpt == 'undefined') ? "" : adressDetail.dpt)
                //    option.value.region = ((typeof adressDetail.region == 'undefined') ? "" : adressDetail.region)
                //    option.value.pays = ((typeof adressDetail.pays == 'undefined') ? "" : adressDetail.pays)
                //    option.value.code_pays = ((typeof adressDetail.code_pays == 'undefined') ? "" : adressDetail.code_pays)
                //    option.value[option.lib_latitude] = ((typeof adressDetail.latitude == 'undefined') ? "" : adressDetail.latitude)
                //    option.value[option.lib_longitude] = ((typeof adressDetail.longitude == 'undefined') ? "" : adressDetail.longitude)
                //    option.value.normalise = 1

                //    mMajIndicateur()
                //    //disableOnValueChanged = true
                //    dx.option("value", Me.mResumeAdresse())
                //    //disableOnValueChanged = false
                //    mMajFlag()
                //})
                disableChange = true
            },
            itemTemplate: function (itemData, itemIndex, itemElement) {
                var $Table = $("<table style='text-align:left;'/>").appendTo(itemElement)
                var $Tr = $("<tr/>").appendTo($Table)
                var $Td = $("<td style='width:1px;padding-right:5px;' rowspan='2'><i class='fas fa-map-marked' style='color:" + theme.backgroundcolorAccent + "'/></td>").appendTo($Tr)
                var $Td = $("<td style='width:100%'>" + itemData.resume + "</td>").appendTo($Tr)
                var $Tr = $("<tr/>").appendTo($Table)
                var $Td = $("<td style='width:100%;font-size:80%;Font-style:italic;'></td>").appendTo($Tr)
                if (itemData.distance_km) {
                    $Td.text(itemData.distance_km + " km")
                }
                $Table.attr("title", itemData.resume)

                ////itemElement.text("sdfsdfsdfsdf")
                //var $Table = $("<table/>").appendTo(itemElement)
                //var $Tr = $("<tr/>").appendTo($Table)
                //var $Td = $("<td style='width:1px;padding-right:5px;' " + ((itemData.distance_meters) ? "rowspan='2'" : "") + "><i class='fas fa-map-marked' style='color:" + theme.backgroundcolorAccent + "'/></td>").appendTo($Tr)
                //var $Td = $("<td style='width:100%'>" + (new cAdresse(itemData)).mGetLibelleLong(true, true) + "</td>").appendTo($Tr)
                //if (itemData.distance_meters) {
                //    var $Tr = $("<tr/>").appendTo($Table)
                //    var tot = itemData.distance_meters / 1000
                //    if (tot < 0) { tot = itemData.distance_meters + " mètres" }
                //    else if (tot < 10) {
                //        tot = Math.floor(itemData.distance_meters / 1000)
                //        var metre = Math.ceil(itemData.distance_meters - tot * 1000)
                //        tot = tot + 'km ' + metre + "m"
                //    } else {
                //        tot = Math.ceil(itemData.distance_meters / 1000) + "km"
                //    }
                //    var $Td = $("<td style='width:100%;font-size:80%;Font-style:italic;'>" + tot + "</td>").appendTo($Tr)
                //}
            },
            onValueChanged: function (e) {
                //console.log("ONVALUECHANGED")
                hasValueChanged = true
                container.attr("title", Me.mResumeAdresse())
                //option.onValueChanged(option.value)
            },
            //onKeyDown: function (e) { if (e.event.keyCode == 13) { e.component.blur() } },
            onFocusIn: function (e) {
                if (disableFocusIn) return
                //if (option.value.normalise == "0" || option.value[option.lib_latitude] == null) {
                //    if (e.component.option("text") != null && e.component.option("text").length > 0) {
                //        currentTextSearch = e.component.option("text")
                //        mRempliDataSource(currentTextSearch)
                //    }
                //}
                hasValueChanged = false
            },
            onFocusOut: function (e) {
                console.log("ONFOCUSOUT")
                window.clearTimeout(timeOutRempliDs)
                if (reqAjax) {
                    reqAjax.abort()
                    reqAjax = null
                }
                e.component.close()
                $DivJaugeSaisie.hide()
                if (hasValueChanged && typeof option.onValueChanged != 'undefined') option.onValueChanged(option.value)
                hasValueChanged = false
                if (typeof option.onFocusOut != 'undefined') option.onFocusOut(e)
            },
            buttons: buttons,
            onContentReady: function (e) {
                var input = $(container.find("input"))
                input.attr('autocomplete', 'fakeautocomplete');
                e.component.element().find("input").attr("name", "kjkjkljlkjlmklmlk")
                if (typeof option.onContentReady != 'undefined') option.onContentReady(e)
                //focus suivant sur enter
                container.find('.dx-texteditor-input').off('keydown.next')
                container.find('.dx-texteditor-input').on('keydown.next', function (e) {
                    const key = e.key || e.keyCode || e.which;
                    if (key === 'Enter' || key === 13) {
                        e.preventDefault();
                        let inputs = $('.dx-texteditor-input:visible');
                        let index = inputs.index(this);
                        if (index > -1 && index + 1 < inputs.length) {
                            inputs.eq(index + 1).focus();
                        }
                    }
                });
            }
        }).dxAutocomplete("instance")
        container.attr("title", Me.mResumeAdresse())
        //dx = $("<div/>").appendTo(container).dxDropDownBox({
        //    labelMode: option.labelMode,
        //    label: option.label,
        //    value: Me.mResumeAdresse(),
        //    placeholder: ((typeof option.placeholder == 'undefined') ? "..." : option.placeholder),
        //    dropDownOptions: { minWidth: 300 },
        //    acceptCustomValue: true,
        //    openOnFieldClick: false,
        //    showDropDownButton: false,
        //    contentTemplate: function (e) {
        //        e.component.content().css("padding", "0")
        //    },
        //    onEnterKey: function (e) {
        //        e.component.blur();
        //    },
        //    onKeyUp: function (e) {
        //        Me.isDirty = true
        //    },
        //    onOpened: function (e) {
        //        if (currentTextSearch != e.component.option("text")) {
        //            window.clearTimeout(timeOutRempliDs)
        //            timeOutRempliDs = window.setTimeout(function () { mRempliDataSource(e.component.option("text")) }, 500);
        //        }
        //        window.setTimeout(function () { e.component.focus(); });
        //    },
        //    onInput: function (e) {
        //        if (currentTextSearch != e.component.option("text")) {
        //            if (e.component.option("opened")) {
        //                window.clearTimeout(timeOutRempliDs)
        //                timeOutRempliDs = window.setTimeout(function () { mRempliDataSource(e.component.option("text")) }, 500);
        //            } else { e.component.open() }
        //        }
        //    },
        //    onFocusOut: function (e) {
        //        timeOutFocus = window.setTimeout(function () { onValueChanged() }, 300)
        //    },
        //    onFocusIn: function (e) {
        //        window.clearTimeout(timeOutFocus)
        //    },
        //    buttons: buttons,
        //    onContentReady: function (e) {
        //        e.component.element().find("input").attr("name", "kjkjkljlkjlmklmlk")
        //    }
        //}).dxDropDownBox("instance");

        mMajIndicateur()
        mMajFlag()

    }

    this.mReload = function () {
        mConstruit()
    }

    function mShowListAdresse(target, type) {
        var tt = $("<div/>").appendTo("body").dxCtrlTooltip({
            target: target,
            width: 300,
            minHeight: 100,
            contentTemplate: function (contentElement) {
                contentElement.css("padding", "20px 10px")
                contentElement.css("text-align","left")
                var jauge = $("<div/>").appendTo(contentElement).dxCtrlJauge({ width: 30, height: 30 }).dxCtrlJauge("instance")
                jauge.mShow();
                var resumeAdresse = (new cAdresse(option.value)).mGetLibelleLong();
                (new cGoogleMapsApi(option.bddCtrl)).mGetLstAdressFromString(resumeAdresse, function (lstAdresse) {
                    if (lstAdresse.length > 0) {
                        $("<div style='font-size:120%;font-weight:bold;'>" + (type == 'geoloc' ? "Choisissez l'adresse pour la géolication" : "Choisissez l'adresse pour la normalisation") + "</div>").appendTo(contentElement)
                        lstAdresse.forEach(function (itemData, idx) {
                            itemData.ad1 = itemData.adr
                            delete itemData.adr
                            if (idx > 0) $("<br/>").appendTo(contentElement)
                            var resAdresse = (new cAdresse(itemData)).mGetLibelleLong(true, true);
                            var $DivAdr = $("<div class='state-hover dx-widget dx-button dx-button-mode-contained dx-button-normal dx-button-has-text' " +
                                "style='padding:10px;width:calc(100% - 40px);height:auto;text-align:left;line-height:1;margin-top:10px;'>" +
                                "<div>" +
                                "<span style='font-family:barlow condensed;white-space:normal;'>" + resAdresse + "</span>" +
                                "</div>" +
                                "</div>").appendTo(contentElement)
                            $DivAdr.on("click", function (e) {
                                tt.hide()
                                if (type == 'geoloc') {
                                    var ttType = $("<div/>").appendTo("body").dxCtrlTooltip({
                                        target: target,
                                        width:300,
                                        contentTemplate: function (contentElement) {
                                            contentElement.css("padding", "20px")
                                            contentElement.css("white-space", "normal")
                                            $("<div style='margin-bottom:5px;'>Que voulez vous modifier sur cette adresse</div>").appendTo(contentElement)
                                            $("<div style='font-style:italic;margin-bottom:10px;'>" + resAdresse + "</div>").appendTo(contentElement)
                                            $("<div style='margin-bottom:15px;'/>").appendTo(contentElement).dxCtrlButton({
                                                text: "Toute l'adresse",
                                                width:"100%",
                                                onClick: function (e) {
                                                    ttType.hide()
                                                    option.value.ad1 = itemData.ad1
                                                    option.value.cp = itemData.cp
                                                    option.value.ville = itemData.ville
                                                    option.value.dpt = itemData.dpt
                                                    option.value.region = itemData.region
                                                    option.value.pays = itemData.pays
                                                    option.value.code_pays = itemData.code_pays
                                                    option.value[option.lib_latitude] = itemData.latitude
                                                    option.value[option.lib_longitude] = itemData.longitude
                                                    option.value.normalise = 1
                                                    if (typeof option.onValueChanged != 'undefined') option.onValueChanged(option.value)
                                                    mConstruit()
                                                }
                                            })
                                            $("<div style='margin-bottom:10px;'/>").appendTo(contentElement).dxCtrlButton({
                                                text: "Uniquement la géolocalisation",
                                                width: "100%",
                                                onClick: function (e) {
                                                    ttType.hide()
                                                    option.value[option.lib_latitude] = itemData.latitude
                                                    option.value[option.lib_longitude] = itemData.longitude
                                                    if (typeof option.onValueChanged != 'undefined') option.onValueChanged(option.value)
                                                    mConstruit()
                                                }
                                            })
                                        }
                                    }).dxCtrlTooltip("instance")
                                    ttType.show()
                                } else {
                                    option.value.ad1 = itemData.ad1
                                    option.value.cp = itemData.cp
                                    option.value.ville = itemData.ville
                                    option.value.dpt = itemData.dpt
                                    option.value.region = itemData.region
                                    option.value.pays = itemData.pays
                                    option.value.code_pays = itemData.code_pays
                                    option.value[option.lib_latitude] = itemData.latitude
                                    option.value[option.lib_longitude] = itemData.longitude
                                    option.value.normalise = 1
                                    if (typeof option.onValueChanged != 'undefined') option.onValueChanged(option.value)
                                    mConstruit()
                                }

                            })
                        })
                        $("<br/>").appendTo(contentElement)
                        var $DivAdr = $("<div class='state-hover dx-widget dx-button dx-button-mode-contained dx-button-normal dx-button-has-text' " +
                            "style='padding:10px;width:calc(100% - 40px);height:auto;text-align:left;line-height:1;margin-top:20px;text-align:center;'>" +
                            "<div style='text-align:center;font-size:120%;width:100%'>" +
                            "<span style='font-family:barlow condensed;white-space:normal;'>OUVRIR L'ADRESSE POSTALE...</span>" +
                            "</div>" +
                            "</div>").appendTo(contentElement)
                        $DivAdr.on("click", function (e) {
                            tt.hide()
                            mShowPopupAdressePostale();
                        })
                    } else {
                        tt.hide()
                        mShowPopupAdressePostale();
                        window.setTimeout(function (e) {
                            mNotify("Impossible de " + (type == 'geoloc' ? "géolocaliser" : "normaliser") + " l'adresse. Aucune adresse trouvée.", "warning", 6000)
                        }, 1000)
                    }
                    jauge.mHide()
                })
            }
        }).dxCtrlTooltip("instance")
        tt.show()
    }

    function mShowPopupAdressePostale() {
        $("<div/>").appendTo("body").dxCtrlPopupAdressePostale({
            bddCtrl: option.bddCtrl,
            value: option.value,
            lib_latitude: option.lib_latitude,
            lib_longitude: option.lib_longitude,
            onValueChanged: function (e) {
                if (typeof option.onValueChanged != 'undefined') option.onValueChanged(option.value)
            },
            onClose: function () {
                mConstruit()
            }
        }).dxCtrlPopupAdressePostale("instance")
    }

    var dsResultAdresse = null
    var currentTextSearch = null;
    var reqAjax = null
    var disableFocusIn = false
    function mRempliDataSource(TextRecherche) {
        $DivJaugeSaisie.show()
        currentTextSearch = TextRecherche;
        dx.close()
        if (reqAjax) {
            reqAjax.abort()
            reqAjax = null
        }
        reqAjax = (new cGoogleMapsApi(option.bddCtrl)).mGetLstAdressFromString((new cAdresse(option.value)).mGetLibelleLong(), function (lstAdresse) {
            reqAjax = null
            dsResultAdresse = lstAdresse
            if (dsResultAdresse.length > 0) {
                dx.close()
                //dx.open()
                console.log(dsResultAdresse)
                disableFocusIn = true
                dx.option("dataSource", dsResultAdresse)
                disableFocusIn = false
                dx.open()
                //mRempliPopup()
            } else {
                console.log("rien")
                dx.option({
                    dataSource: []
                })
                //if (dx.content() != null) dx.content().empty()
                dx.close()
            }
            $DivJaugeSaisie.hide()
        })
        //reqAjax = (new serviceMapsApi()).mGetLstAdressFromString(currentTextSearch, function (dsResult) {
        //    reqAjax = null
        //    dsResultAdresse = dsResult
        //    if (dsResultAdresse.length > 0) {
        //        dx.close()
        //        //dx.open()
        //        console.log(dsResultAdresse)
        //        disableFocusIn=true
        //        dx.option("dataSource", dsResultAdresse)
        //        disableFocusIn=false
        //        dx.open()
        //        //mRempliPopup()
        //    } else {
        //        console.log("rien")
        //        dx.option({
        //            dataSource: []
        //        })
        //        //if (dx.content() != null) dx.content().empty()
        //        dx.close()
        //    }
        //    $DivJaugeSaisie.hide()
        //})
    }
    function mMajFlag() {
        if (option.hideButton) return
        if (option.value.code_pays != null && option.value.code_pays.length > 0) {
            dxBtFlag.option("visible", true)
            dxBtFlag.option("icon", "https://flagcdn.com/w20/" + option.value.code_pays.toLowerCase() + ".png")
        } else { dxBtFlag.option("visible", false) }
    }
    function mMajIndicateur() {
        if (option.hideButton) return
        if (Me.hasValue() && option.value.normalise == "0") { dxBtNormalise.option("visible", true) } else { dxBtNormalise.option("visible", false) }
        if (Me.hasValue() && option.value[option.lib_latitude] == null) { dxBtGeocode.option("visible", true) } else { dxBtGeocode.option("visible", false) }
    }

    this.hasValue = function () {
        return this.mResumeAdresse().length > 0
    }

    this.setValue = function (value) {
        option.value = value
        dx.option("value", Me.mResumeAdresse())
    }

    this.mResumeAdresse = function () {
        //if (option.value.normalise == 0) { return ((option.value.ad1 == null) ? "" : option.value.ad1) }
        //else {
        var txt = ((option.value.ad1 == null) ? "" : option.value.ad1.trim())
        if (option.value.cp != null && option.value.cp.trim().length > 0) {
            if (txt.length > 0) txt += ", "
            txt += option.value.cp.trim()
        }
        if (option.value.ville != null && option.value.ville.trim().length > 0) {
            if (txt.length > 0) {
                if (option.value.cp != null && option.value.cp.length > 0) { txt += " " }
                else { txt += ", " }
            }
            txt += option.value.ville.trim()
        }
        if (option.value.region != null && option.value.region.trim().length > 0) {
            if (txt.length > 0) txt += ", "
            txt += option.value.region.trim()
        }
        if (option.value.pays != null && option.value.pays.trim().length > 0) {
            if (txt.length > 0) txt += ", "
            txt += option.value.pays.trim()
        }
        return txt
        //}
    }

    this.element = function () { return container; }
    this.focus = function () { dx.focus() }

    mConstruit();
}

window.imgJaugeSaisie = "data:image/gif;base64,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"